// extracted by mini-css-extract-plugin
module.exports = {"sub-processors":"sub-processors_sub-processors__VsVrt"};